import React, { useEffect } from 'react';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}
const PIXEL_ID = '1418484353734832';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
    } as Fbq;
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-210" data-mp="18frw4zvqtd3v">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-211" data-mp="18fi2n2bhontf" />
    </noscript>;
}